/**
 * @file: 商品拖拽落位指示箭头
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../../cubeTree/index';
import * as UIToolkit from '../../../UIToolkit';
import CodiSystem from '../../../codiSystem/index';
import Utils from '../../../utils/util';
import ArrowBase from '../arrow/index';
import { findTargetFreezer } from '../funcs/findTargetFreezer';
import { findTargetCabinetChild } from '../funcs/findTargetCabinetChild';

class InsertArrow extends ArrowBase {
    private colPaintCoordinates: ColCubePaintCoordinate[];
    private insertInfo: CabinetCubeInsertInfo = {
        target: null,
        direction: '',
        arrowPosition: {
            left: 0,
            top: 0
        }
    };

    constructor() {
        super();
    }

    move(params: ArrowMoveParams): void {
        this.target = null;
        this.direction = null;

        // 查询鼠标点所在货架
        let targetFreezer: CubeId|null = findTargetFreezer(params.shelfsCoordinate, params.mousePoint, []);

        // 没有查询到货架，落位到画布
        if (!targetFreezer) {
            this.toSketchpad();
            return;
        }

        this.toFreezer(targetFreezer, params.mousePoint, params.dragCubes);
    }

    private toSketchpad(): void {
        this.insertInfo = {
            target: CubeTree.findSketchpad(),
            direction: ''
        };
        this.pointTo();
    }

    private toFreezer(targetFreezer: CubeId, mousePoint: MousePoint, dragCubes: CubeId[]): void {
        // 插入空卧柜
        if (CubeTree.isEmptyFreezer(targetFreezer)) {
            this.insertInfo = {
                target: CubeTree.findFreezersCabinet(targetFreezer),
                direction: ''
            };
            this.pointTo();
            return;
        }

        // 查询鼠标点所在商品、文本框、隔板
        this.insertInfo = findTargetCabinetChild({
            targetFreezer,
            mousePoint,
            dragCubes,
            colPaintCoordinates: this.colPaintCoordinates,
        });

        if (CubeTree.isCabinet(this.insertInfo.target)) {
            this.pointTo();
            return;
        }

        // 显示插入箭头
        this.pointTo();
    }

    // 鼠标箭头指向渲染
    private pointTo(): void {
        if (!this.insertInfo.target
            || CubeTree.isSketchpad(this.insertInfo.target)) {
            this.destroy();
            return;
        }

        if (CubeTree.isCabinet(this.insertInfo.target)) {
            // 箭头指向层板
            this.pointToCabinet(this.insertInfo.target);
            return;
        }

        // 箭头指向层板上的组件
        this.pointToCabinetCube(this.insertInfo);
    }

    // 计算商品列坐标
    protected updateColPaintCoordinates(): void {
        this.colPaintCoordinates = UIToolkit.getColPaintCoordinates();
    }
}

export default InsertArrow;
